import { NavLink, Outlet, useLocation, useSearchParams } from 'react-router-dom';
import * as styles from './analyticsPageStyles';

const tabs: { path: string; label: string }[] = [
  { path: 'adoption', label: 'Adoption' },
  { path: 'payments', label: 'Payments' },
  { path: 'usage', label: 'Usage' },
  { path: 'trends', label: 'Trends' },
];

function mergeQuery(base: URLSearchParams, path: string): string {
  const next = new URLSearchParams(base);
  if (path !== 'adoption' && path !== 'trends') {
    next.delete('granularity');
  }
  const qs = next.toString();
  return qs ? `?${qs}` : '';
}

/**
 * Analytics subsection tabs; preserves period (and granularity when relevant) in the URL.
 */
export function AnalyticsLayout() {
  const location = useLocation();
  const [searchParams] = useSearchParams();

  return (
    <div style={styles.analyticsLayout}>
      <h1 style={styles.title}>Analytics</h1>
      <div style={styles.subNav} role="tablist" aria-label="Analytics sections">
        {tabs.map((tab) => {
          const to = `/analytics/${tab.path}${mergeQuery(searchParams, tab.path)}`;
          const active = location.pathname.endsWith(`/analytics/${tab.path}`);
          return (
            <NavLink
              key={tab.path}
              to={to}
              style={{ ...styles.subNavLink, ...(active ? styles.subNavLinkActive : {}) }}
              role="tab"
              aria-selected={active}
              data-testid={`analytics-tab-${tab.path}`}
            >
              {tab.label}
            </NavLink>
          );
        })}
      </div>
      <Outlet />
    </div>
  );
}
